// extracted by mini-css-extract-plugin
module.exports = {"gauge":"PercentageGauge_gauge__vizOJ"};